<!--
 * @Description: 用水报装
 * @FilePath: /netHallOfficialAccounts/src/views/Business/Expand/InstallWater.vue
-->
<template>
  <div>
    <div>
      <business-status
        v-if="statusInfor"
        :statusInfor="statusInfor"
        :flowNodes="flowNodes"
        :busHandlingId="busHandlingId"
      />
      <div class="real-infor">
        <van-form ref="realInfo">
          <!-- <van-field readonly :label="labelName" input-align="right">
            <template #input>
              <span>{{ realName.name }}</span>
            </template>
          </van-field> -->
          <van-field
            :label="labelName"
            name="name"
            required
            :readonly="isFormReadOnly"
            :input-align="realAlign"
            v-model="realName.name"
            :placeholder="`请填写${labelName}`"
            :rules="[
              { required: true },
              { pattern: /^[\u4e00-\u9fa5]{2,30}$/, message: '必须是长度为2到30的中文！' }
            ]"
          />
          <van-field
            label="手机号"
            name="phone"
            required
            :readonly="isFormReadOnly"
            :input-align="realAlign"
            v-model="realName.phone"
            :placeholder="`请填写${labelName}手机号`"
            :rules="[
              { required: true },
              { pattern: /^((13\d)|(14[5,7,9])|(15[0-3,5-9])|(166)|(17[0,1,3,5,7,8])|(18[0-9])|(19[8,9]))\d{8}$/, message: '请输入正确手机号码' }
            ]"
          />
          <van-field
            label="证件号码"
            name="idNumber"
            required
            :readonly="isFormReadOnly"
            :input-align="realAlign"
            v-model="realName.idNumber"
            :placeholder="`请填写${labelName}证件号码`"
            :rules="[
              { required: true },
              { pattern: /^[1-9]\d{5}(?:18|19|20)\d{2}(?:0[1-9]|10|11|12)(?:0[1-9]|[1-2]\d|30|31)\d{3}[\dXx]$/, message: '请输入正确身份证号' }
            ]"
          />
        </van-form>
      </div>
    </div>
    <div class="vant-parser">
      <parser
        v-if="formConf"
        :notify="notify"
        ref="parser"
        :key="key2"
        :form-conf="formConf"
        @submit="sumbitForm1"
        @failed="failedForm"
      />
    </div>
    <div class="vant-parser">

    </div>
    <!-- [nh_00]办理中状态显示 -->
    <div class="footer" v-if="this.businessState === 'see' && currentFormData && ( currentFormData.orderState === 'PRE_AUDITING' ||
              currentFormData.orderState === 'PRE_AUDIT_FAILED')">
      <div class="btns">
        <van-button plain type="info" @click="showCancelReport" style="margin-right: 10px">
          取消办理
        </van-button>
        <van-button plain type="info" @click="updateInfo">修改信息</van-button>
      </div>
    </div>
  </div>
</template>

<script>
import store from '@/store';
import { mapState } from 'vuex';
import { findParentIdsById } from '@/utils/tools.js'
import { Dialog, Toast } from 'vant';
import Parser from '@/components/vant-parser/Parser';
import {
  addBusHandling,
  selectHandUser,
  selectBusHandlingById,
  updateBusHandling,
  cancelReport,
  getAbodeTreeByTenantId,
  getAbodeTreeByTenantIdAndUsedId
} from '@/api/business';
import { installFormData } from './install';
import BusinessStatus from '../components/BusinessStatus';
export default {
  components: {
    Parser,
    BusinessStatus,
  },
  data() {
    return {
      key2: +new Date(),
      formConf: null,
      businessCode: null,
      moduleCode: null,
      custReadingId: null,
      busHandlingId: null,
      /* businessState: add-新增；see-查看；edit-修改 */
      businessState: null,
      /* 页面修改，取消 */
      stateBoolean: false,
      formReleaseId: null,
      abodeList: [],
      /* 实名认证信息 */
      realName: {
        name: null,
        phone: null,
        idNumber: null,
        abodeName: '',
        abodeCode: '',
      },
      initData:{
        abodeName: '',
        abodeCode: '',
        name: '',
        mobile: '',
        locatedAddress: '',
        addressDetail: '',
        intro: '',
        idCardF: '',
        idCardB: '',
        materials: ''
        // abodeCode: ''
      },
      /* 业务办理信息 */
      statusInfor: null,
      /* 流程节点数组 */
      flowNodes: [],
      labelName: '办理人',
      notify: '提示： 需上传房主身份证照片、购房合同、开户通知单照片',
      isShowFrom: false,
      currentFormData: null,
      /* 路由参数控制只读 */
      isReadOnlyFromRoute: false,
      /* 从localStorage获取的表单数据 */
      orderContentData: null
    };
  },
  computed: {
    ...mapState('user', {
      homeInfo: (state) => state.homeInfo,
      businessNews: (state) => state.businessNews,
      userInfo: (state) => state.userInfo,
    }),
    renamedFormData(){
      return installFormData(this)
    },
    realAlign() {
      if (this.businessState !== 'see' && !this.isReadOnlyFromRoute) {
        return 'left';
      }
      return 'right';
    },
    /* 是否只读（包括路由参数和业务状态） */
    isFormReadOnly() {
      return this.isReadOnlyFromRoute || this.businessState === 'see';
    },
  },
  async mounted() {
    // 检查路由参数中是否有 readOnly
    const readOnly = this.$route.query.readOnly;
    if (readOnly !== undefined && !!readOnly) {
      this.isReadOnlyFromRoute = true;
    }
    await this.into();
    await this.getAbodeCode(this.userInfo.tenantId);
    if (this.isFormReadOnly) {
      this.fileOrderDetail()
    }

  },
  methods: {
    // 回显表单数据
    fileOrderDetail(){
        const currentFormDataStr = localStorage.getItem("currentFormData");
        if (currentFormDataStr) {
          try {
            const currentFormData = JSON.parse(currentFormDataStr);
            this.currentFormData = currentFormData;
            this.bizHandleId = currentFormData.bizHandleId
            let orderContent = currentFormData.orderContent
              ? JSON.parse(currentFormData.orderContent)
              : [];
            // 将orderContent数组转换为对象格式，用于表单回填
            this.orderContentData = this.convertOrderContentToFormData(orderContent);
            // 如果currentFormData中有证件号码信息，也保存下来
            if (currentFormData.idNumber || currentFormData.idCard) {
              this.orderContentData.idNumber = currentFormData.idNumber || currentFormData.idCard;
            }

            // 如果表单已经加载，立即回填
            if (this.formConf && this.$refs.parser) {
              this.$nextTick(() => {
                this.fillFormFromOrderContent();
              });
            }
          } catch (e) {
            console.error('解析currentFormData失败:', e);
          }
        }
        console.log(this.currentFormData.orderState,'当前状态')
    },
    // tree-select 选择变化事件处理
    handleTreeSelectChange(event) {
      if (event && event.label && event.value) {
        this.realName.abodeName = event.label;
        this.realName.abodeCode = event.value;
      }
    },
    // 表单数据回填
    fillFormData (form, data) {
      // const data = {
      //   mobile: '18836662555',
      // };
      // // 回填数据
      // this.fillFormData(this.formConf, data);
      form.fields.forEach((item) => {
        const val = data[item.__vModel__];
        if (val) {
          item.__config__.defaultValue = val;
        }
      });
    },
    // 将orderContent数组转换为表单数据对象
    convertOrderContentToFormData(orderContent) {
      const formData = {};
      if (!Array.isArray(orderContent)) {
        return formData;
      }

      orderContent.forEach((item) => {
        if (item.key && item.value !== undefined && item.value !== null) {
          // 对于upload类型，直接使用包含url信息的对象数组
          if (item.type === 'upload' && Array.isArray(item.value)) {
            // 构造包含url信息的对象数组，直接使用url显示图片
            const uploadData = item.value.map(file => ({
              fileId: file.fileId,
              id: file.fileId,
              url: file.url || file.fileNetPath || file.filePath
            }));
            formData[item.key] = JSON.stringify(uploadData);
          } else {
            // 对于其他类型，直接使用原值
            formData[item.key] = item.value;
          }
        }
      });

      return formData;
    },
    // 在options中根据label查找对应的value
    findOptionByLabel(options, label) {
      if (!Array.isArray(options)) {
        return null;
      }

      for (const option of options) {
        if (option.label === label) {
          return option;
        }
        // 递归查找children
        if (option.children && Array.isArray(option.children)) {
          const found = this.findOptionByLabel(option.children, label);
          if (found) {
            return found;
          }
        }
      }

      return null;
    },
    // 从orderContent回填表单
    fillFormFromOrderContent() {
      if (!this.orderContentData || !this.$refs.parser) {
        return;
      }

      // 处理tree-select类型的值转换（如果value是字符串label，需要转换为对应的value）
      const formData = { ...this.orderContentData };
      if (formData.abodeName && typeof formData.abodeName === 'string' && this.abodeList && this.abodeList.length > 0) {
        // 在abodeList中查找匹配的选项
        const matchedOption = this.findOptionByLabel(this.abodeList, formData.abodeName);
        if (matchedOption) {
          formData.abodeName = matchedOption.value;
        }
      }

      // 回填表单数据
      this.$refs.parser.fillForm(formData);
      const { name='' ,mobile='', idNumber='',abodeCode='' } = this.orderContentData
      this.realName = { name ,phone:mobile,idNumber, abodeCode }
      // abodeName 和 abodeCode 需要从原始数据中获取（保持原始值，用于显示）
      if (this.orderContentData.abodeName) {
        this.realName.abodeName = typeof this.orderContentData.abodeName === 'string'
          ? this.orderContentData.abodeName
          : (this.findOptionByValue(this.abodeList, this.orderContentData.abodeName)?.label || '');
      }
    },
    // 在options中根据value查找对应的label
    findOptionByValue(options, value) {
      if (!Array.isArray(options)) {
        return null;
      }

      for (const option of options) {
        if (option.value === value) {
          return option;
        }
        // 递归查找children
        if (option.children && Array.isArray(option.children)) {
          const found = this.findOptionByValue(option.children, value);
          if (found) {
            return found;
          }
        }
      }

      return null;
    },
    /* 页面初始化 */
    into() {
      // 从store中获取业务信息
      if (this.businessNews && this.businessNews.busHandlingId) {
        this.busHandlingId = this.businessNews.busHandlingId;
      }
      if (this.businessNews && this.businessNews.businessState) {
        this.businessState = this.businessNews.businessState;
      }

      if (this.businessState === 'add') {
        // this.selectHandUser();
      } else if (this.businessState === 'see' && this.busHandlingId) {
        // 查看状态下，加载详情数据
        this.selectBusHandlingById(this.busHandlingId);
      }

      if (this.businessNews && this.businessNews.moduleName !== undefined && this.businessNews.moduleName) {
        document.title = this.businessNews.moduleName;
      } else {
        document.title = '用水报装';
      }
    },
    failedForm() {
      this.$refs['realInfo'].validate().then((res) => {
      }).catch((error) => {
      });
    },
    // 转换表单配置和数据为目标格式
    convertFormToTargetFormat(formConf, formData) {
      const form = [];

      // 递归处理字段
      const processFields = (fields) => {
        fields.forEach((field) => {
          const config = field.__config__ || {};

          // 如果是 row 类型，处理其 children
          if (config.layout === 'rowFormItem' && config.children) {
            processFields(config.children);
            return;
          }

          // 如果是实际的表单字段
          if (field.__vModel__ && config.layout === 'colFormItem') {
            const key = field.__vModel__;
            const label = config.label || '';
            let value = formData[key] !== undefined ? formData[key] : null;

            // 根据 tag 确定 type
            let type = 'input';
            const tag = config.tag || field._tag || '';
            if (tag === 'el-tree-select' || tag === 'vc-tree-select' || tag === 'a-tree-select') {
              type = 'tree-select';
            } else if (tag === 'el-upload' || tag === 'a-upload' || tag === 'vc-uploader') {
              type = 'upload';
              // 处理 upload 类型的 value，避免多包一层数组
              if (value !== null && value !== undefined) {
                // 如果是字符串，尝试解析为数组
                if (typeof value === 'string') {
                  try {
                    value = JSON.parse(value);
                  } catch (e) {
                    // 解析失败，保持原值
                    value = null;
                  }
                }
                // 如果已经是数组，确保不是嵌套数组
                if (Array.isArray(value) && value.length > 0 && Array.isArray(value[0])) {
                  // 如果多包了一层数组，取第一层
                  value = value[0];
                }
                // 确保最终是数组或 null
                if (!Array.isArray(value)) {
                  value = null;
                }
              }
            } else if (field.type === 'textarea') {
              type = 'textarea';
            } else {
              type = 'input';
            }

            // 构建字段对象
            const fieldObj = {
              key: key,
              label: label,
              type: type,
              value: value,
              disabled: false,
            };

            // 如果是 tree-select 类型，添加 options
            if (type === 'tree-select' && field.options) {
              fieldObj.options = field.options;
            } else if (type === 'tree-select') {
              fieldObj.options = [];
            }

            form.push(fieldObj);
          }
        });
      };

      if (formConf && formConf.fields) {
        processFields(formConf.fields);
      }
      form.push({ "key": "abodeCode", "label": "站点编号", "type": "input", "value": this.realName.abodeCode })
      const manageSiteIds = findParentIdsById(this.abodeList, this.realName.abodeCode)
      form.push({
        key: "manageSiteIds",
        label: "站点数组",
        type: "input",
        value: manageSiteIds,
        disabled: true
      })
      return form;
    },
    /* 页面提交 */
    sumbitForm1(data) {
      // 如果路由参数有readOnly，禁止提交
      if (this.isReadOnlyFromRoute) {
        Toast('当前表单为只读模式，无法提交');
        return;
      }
      let userInfo = store.getters.userInfo;
      this.$refs['realInfo'].validate().then((res) => {
        let formData = { ...data, ...this.realName };
        // if (this.businessState === 'add') {
          // 转换表单数据为目标格式
          const form = this.convertFormToTargetFormat(this.formConf, formData);

          let params = {
          bizCode: 'PSN_BBZ', // 业务类型编码
          bizHandleId: "",
          // 选择水户绑定的信息
          clientAddress:  "", // 用水户地址
          clientCode:  "", // 用水户户号
          clientName:  "", // 用水户户名
          customerNo:  "",
          abodeName: this.realName.abodeName,
          abodeCode: this.realName.abodeCode,
          contacts: formData.name,
          // 登录人信息
          idCard: formData.idNumber, // 办理人身份证号码
          orderSource: "wx", // 表单申请人人手机号
          phone: formData.phone, // 表单申请人人手机号
          transactor: formData.name,
          userId: userInfo.userId, // 登陆人id
          form: form, // 表单数据
        };
        this.addBusHandling(params);
      //   // } else {
      //   //   let updateArg = {
      //   //     busHandlingId: this.busHandlingId,
      //   //     formReleaseIds: this.formReleaseId,
      //   //     formContent: JSON.stringify(formData),
      //   //     verification: {
      //   //       moduleCode: this.moduleCode,
      //   //     },
      //   //   };
      //   //   this.updateBusHandling(updateArg);
      //   // }
      }).catch((error) => {

      });
    },
    getAbodeList (value) {
      let list = [];
      list = value.map((item) => {
        return {
          ...item,
          name: item.name,
          label: item.name,
          value: item.data?item.data.id: item.id,
          children:
            item.children && item.children.length > 0
              ? this.getAbodeList(item.children)
              : [],
        };
      });
      return list;
    },
    async getAbodeCode (userId) {
      let res = await getAbodeTreeByTenantId(userId);
      const data = res.resultData
      if (data.length > 0) {
        this.abodeList =[this.getAbodeList(data)[0]];
        console.log(this.abodeList)

        let dataForm = this.renamedFormData;
        this.formReleaseId = "abfdcf857591ab1a0215f423e967bd43";
        dataForm.fields[0].__config__.children[0].options = this.abodeList;

        // 如果是查看状态或路由参数有readOnly，设置表单为只读
        if (this.businessState === 'see' || this.isReadOnlyFromRoute) {
          dataForm = { ...dataForm, readonly: true };
        }

        this.formConf = dataForm;
        console.log(this.formConf, 'formConf');
        this.isShowFrom = true;

        // 如果是在查看状态且有busHandlingId，加载详情数据
        if (this.businessState === 'see' && this.busHandlingId) {
          this.selectBusHandlingById(this.busHandlingId);
        }

        // 如果有orderContent数据，回填表单
        if (this.orderContentData && this.$refs.parser) {
          this.$nextTick(() => {
            this.fillFormFromOrderContent();
          });
        }
      }
    },
    initAbodeList (isInitial) {
      this.formConf.fields[0]['__config__'].children[0].options = this.abodeList;
      this.fillFormData(this.formConf,this.initData)
    },
    // 取消
    showCancelReport() {
      Dialog.confirm({
        message: '您确定取消申请吗？',
        confirmButtonText: '取消申请',
        confirmButtonColor: '#3C7EF0',
        cancelButtonText: '点错了',
        cancelButtonColor: '#767E8C',
      })
        .then(() => {
          this.cancelReport();
        })
        .catch(() => {
          console.log('取消申请');
        });
    },
    /* 取消 */
    async cancelReport() {
      let userInfo = store.getters.userInfo;
      let params = {
        auditBy:  userInfo.userId,
        auditContent: "",
        auditor:  userInfo.nickName,
        bizHandleId: this.bizHandleId,
        event: "CANCEL_TASK",
      };
      const { status, resultData } = await cancelReport(params);
      if (status === 'complete') {
        Toast('该业务已取消');
        // 回显页面
        this.setBusinessNews('see');
        this.key2 = +new Date();
        this.formConf = { ...this.formConf, readonly: true };
        await this.selectBusHandlingById(this.busHandlingId);
        this.fileOrderDetail()
        this.businessState = ''
      }
    },
    /* 修改信息 */
    async updateInfo(data) {
      this.setBusinessNews('edit');
      this.key2 = +new Date();
      this.formConf = { ...this.formConf, readonly: false };
      await this.selectBusHandlingById(this.busHandlingId);
      this.fileOrderDetail()
    },
    /* 查询实名信息 */
    async selectHandUser() {
      let userInfo = store.getters.userInfo;
      console.log(userInfo)
      let waterUserNo = '';
      const { status, resultData } = await selectHandUser('');
      if (status === 'complete' && resultData) {
        this.realName.name = resultData.handUserVO.clientName;
        this.realName.phone = resultData.handUserVO.phone;
        // this.realName.idNumber = resultData.handUserVO.idNumber;
      }
    },
    /* 获取表单样式 */
    async selectMaxRelease() {
      let data = this.renamedFormData;
      this.formReleaseId = "abfdcf857591ab1a0215f423e967bd43";
      if (this.businessState === 'see' || this.isReadOnlyFromRoute) {
        data.fields[0]['__config__'].children[0].options = this.abodeList;
        data = { ...data, readonly: true };
      }
      this.formConf = data;
      console.log(this.formConf, 'formConf');
      this.isShowFrom = true;
      // let arg = {
      //   businessCode: this.businessCode,
      //   moduleCode: this.moduleCode,
      // };
      // const { status, resultData } = await selectMaxRelease(arg);
      // if (status === 'complete' && resultData) {
      //   this.formReleaseId = resultData.formReleaseId;
      //   let data = JSON.parse(resultData.content);
      //   if (this.businessState === 'see') {
      //     data = { ...data, readonly: true };
      //   }
      //   this.formConf = data;
      //   console.log(this.formConf, 'formConf');
      //   if (this.busHandlingId) {
      //     this.selectBusHandlingById(this.busHandlingId);
      //   }
      // }
    },
    /* 数据查询 */
    async selectBusHandlingById(id) {
      const { status, resultData } = await selectBusHandlingById(id);
      if (status === 'complete') {
          // 按时间排序，获取最新的节点
          const sortedData = [...resultData].sort((a, b) => {
            const timeA = new Date(a.createTime).getTime();
            const timeB = new Date(b.createTime).getTime();
            return timeB - timeA; // 降序，最新的在前
          });
          const latestNode = sortedData[0];
          console.log('latestNode', latestNode)
          // 保存完整的流程节点数组（按时间正序排列，用于显示时间线）
          this.flowNodes = [...resultData].sort((a, b) => {
            const timeA = new Date(a.createTime).getTime();
            const timeB = new Date(b.createTime).getTime();
            return timeA - timeB; // 升序，最早的在前
          });
          // 转换为 BusinessStatus 组件需要的格式
          this.statusInfor = {
            progessName: latestNode.postBizStatus || '',
            progessStatus: this.mapStatusToCode(latestNode.postBizStatus),
            progessStatusName: latestNode.eventDesc || latestNode.auditContent || '',
            progessCreateTime: latestNode.createTime,
            progessRemark: latestNode.auditContent || '',
            processingDays: null, // 如果需要可以从其他地方获取
            stateBoolean: false // 根据业务状态判断
          };
      const formData = { ...this.orderContentData };
          // 设置实名信息
          this.realName = {
            name: formData.name || formData.contacts || '',
            phone: formData.phone || formData.contactNum || formData.mobile || '',
            idNumber: formData.idNumber || formData.idCard || '',
            abodeName: formData.abodeName || '',
            abodeCode: formData.abodeCode || '',
          };
          // 如果表单配置已加载，回填数据
          if (this.formConf && this.$refs.parser) {
            this.$nextTick(() => {
              this.$refs.parser.fillForm(formData);
            });
          }
        } else {
          this.statusInfor = null;
        }
    },
    /* 将状态名称映射为状态码 */
    mapStatusToCode(statusName) {
      const statusMap = {
        '资料审核中': 'nh_00_01_st',
        '处理中': 'nh_01_00_st',
        '已办结': 'nh_03_00_st',
        '已拒绝': 'nh_02_00_st',
        '已作废': 'nh_02_00_st'
      };
      return statusMap[statusName] || 'nh_00_01_st';
    },
    /* 新增提交 */
    async addBusHandling(data) {
      const { status, resultData } = await addBusHandling(data);
      if (status === 'complete') {
        let processingDays = resultData.processingDays;
        this.busHandlingId = resultData.busHandlingId;
        this.handerDialog('提交', processingDays);
      }
    },
    /* 修改更新 */
    async updateBusHandling(arg) {
      const { status, resultData } = await updateBusHandling(arg);
      if (status === 'complete') {
        let processingDays = resultData.processingDays;
        this.busHandlingId = resultData.busHandlingId;
        this.handerDialog('修改', processingDays);
      }
    },
    /* 成功后弹框 */
    handerDialog(dialogName, processingDays) {
      Dialog.alert({
        title: `您的业务办理已${dialogName}成功！`,
        message:
          processingDays !== undefined
            ? `预计在${processingDays}个工作日内完成，请耐心等待，可至"我的办理"中查看办理进度。`
            : '可至"我的办理"中查看办理进度。',
        confirmButtonText: '返回首页',
        confirmButtonColor: '#3C7EF0',
      })
        .then(() => {
          // 返回首页
          this.$router.push({ path: '/' });
        });
    },
    /* 业务全局变量修改 */
    setBusinessNews(State) {
      this.businessState = State;
      let item = {
        ...this.businessNews,
        businessState: State,
        busHandlingId: this.busHandlingId,
      };
      store.dispatch('user/setBusinessNews', item);
    },
  },
};
</script>

<style lang="less" scoped>
.vant-parser {
  margin: 16px 16px 180px 16px;
  overflow: hidden;
  /* margin-bottom: 400px; */
}
.real-infor {
  margin: 16px;
  border-radius: 6px;
  /* overflow: hidden; */
}
.footer {
  display: flex;
  justify-content: space-between;
  padding: 15px 0px 15px 0px;
  background: #ffffff;
  width: 100%;
  position: fixed;
  bottom: 0px;

  .btns {
    width: 100%;
    text-align: center;
    margin: 0px 16px 0px 16px;
    /deep/.van-button--normal {
      width: calc(100% / 2 - 10px);
      border-radius: 8px;
    }
  }
}
</style>
